import { AudioRecordingModelData } from "@/store/audio-recordings";
import {
  AudioRecordingProcessingStatus,
  AudioRecordingRetranscriptionStatus,
} from "@/store/audio-recordings/types";
import {
  BaseAudioRecordingAppEventOperation,
  BaseAudioRecordingAppEventOperationParams,
} from "./BaseAudioRecordingAppEventOperation";

/**
 * Operation to mark that an audio recording failed during retranscription.
 * This is called when the retranscription API call fails or returns empty content.
 */
export class MarkErrorRetranscribingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind() {
    return "MARK_ERROR_RETRANSCRIBING_AUDIO_RECORDING" as const;
  }

  constructor(params: BaseAudioRecordingAppEventOperationParams) {
    super(params);
  }

  protected getModelDataUpdates(
    existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    if (existingData.retranscription_status === AudioRecordingRetranscriptionStatus.COMPLETED) {
      return {};
    }

    const updates: Partial<AudioRecordingModelData> = {
      retranscription_status: AudioRecordingRetranscriptionStatus.ERROR,
    };

    // Only propagate retranscription failure to processing when the core processing flow
    // has not already completed (e.g. avoid failing post-facto/manual retranscribes).
    if (existingData.processing_status !== AudioRecordingProcessingStatus.COMPLETED) {
      updates.processing_status = AudioRecordingProcessingStatus.ERROR;
    }

    return updates;
  }
}
